import { IconButton, useTheme } from "@mui/material";
import { CloseIcon } from "components";
import { useGlobalStore } from "controller";
import dayjs from "dayjs";
import { useAtom } from "jotai";
import { AiBannerShell } from "../ai-banner-shell/AiBannerShell";
import { trialBannerDismissedAtom } from "./store/trialBannerAtoms";

const TRIAL_BANNER_VISIBLE_DAYS = 1;

export const isWithinTrialBannerWindow = (mspCreatedAt: string | null) =>
  !!mspCreatedAt &&
  dayjs().isBefore(dayjs(mspCreatedAt).add(TRIAL_BANNER_VISIBLE_DAYS, "day"));

export const TrialBanner = () => {
  const theme = useTheme();
  const [isDismissed, setIsDismissed] = useAtom(trialBannerDismissedAtom);
  const isNewSignup = useGlobalStore((state) =>
    isWithinTrialBannerWindow(state.mspCreatedAt),
  );

  if (!isNewSignup || isDismissed) return null;

  return (
    <AiBannerShell message="Platform and DeskDay AI are now on trial for 14 days.">
      <IconButton
        aria-label="Dismiss trial banner"
        onClick={() => setIsDismissed(true)}
        sx={{
          width: "16px",
          height: "16px",
          ":hover": {
            bgcolor: "transparent",
          },
        }}
      >
        <CloseIcon
          sx={{ width: "16px", height: "16px" }}
          htmlColor={theme.palette.lightBg.high}
        />
      </IconButton>
    </AiBannerShell>
  );
};
